import React, { useCallback } from 'react';

import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { hasNewPermissionSel } from '@shared';
import { Button } from '@shared/components';
import type { ButtonProps } from '@shared/components/Button/Button';
import { newPermissions } from '@shared/newPermissions';

import { isSubUnitAllowedSel, subUnitTypeNameSel } from '../../duck';
import { showSetSubUnitModal } from '../../duck/actions';

const AddSubUnitButton: React.FC<ButtonProps> = ({ ...props }) => {
  const dispatch = useDispatch();
  const subUnitTypeName = useSelector(subUnitTypeNameSel);
  const isSubUnitAllowed = useSelector(isSubUnitAllowedSel);
  const canEditSubUnits = useSelector(state =>
    hasNewPermissionSel(state, newPermissions.EDIT_UNIT),
  );

  const handleOnClick = useCallback(() => {
    dispatch(showSetSubUnitModal());
  }, [dispatch]);

  return isSubUnitAllowed && canEditSubUnits ? (
    <Button {...props} uppercase={false} onClick={handleOnClick}>
      <FormattedMessage
        id={`packRoster.AddSubUnit.AddSubUnitForm.addSubUnitButton.${subUnitTypeName}`}
      />
    </Button>
  ) : null;
};

export default AddSubUnitButton;
